import { render, staticRenderFns } from "./Ords.vue?vue&type=template&id=e3e22d50&"
import script from "./Ords.vue?vue&type=script&lang=js&"
export * from "./Ords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports